<!-- My Home pafe -->
<template>
  <div class="section text-center" v-if="loading">
    <div class="spinner-border text-primary" role="status"></div>
  </div>
  <div class="home" v-if="!loading">
    <div class="section wallet-card-section mb-1" v-if="banners.length">
      <Flicking :options="{ renderOnlyVisible: true, panelsPerView: 1, align: 'prev', circular: true }"
        :plugins="pluginsBanner">
        <div class="card-panel mt-2" v-for="banner in banners" :key="banner">
          <div class="card card-slider">
            <img :src="'https://guide.msoftit.com/' + banner.image" class="card-img-top" alt="image">
            <!-- <div class="card-body">
              <h5 class="card-title mal-text">{{ banner.title }}
              </h5>
              <p class="card-text mal-text" v-html="banner.content">
              </p>
            </div> -->
          </div>
        </div>
      </Flicking>
    </div>
    <!-- Date Section -->
    <div class="section mb-1" v-if="today.gregorian.year">
      <div class="date-widget-card" :class="[dynamicBgClass, dateWidgetTextClass]">
        <div class="date-widget-header">
          <div class="date-widget-time-group">
            <span class="date-widget-time">{{ currentTimeOnly }}</span>
            <span class="date-widget-ampm">{{ currentAmPm }}</span>
          </div>
          <span class="date-widget-icon">
            <ion-icon :name="dateWidgetIcon" class="dateWidgetIconClass" :class="dateWidgetIconClass"></ion-icon>
          </span>
        </div>
        <div class="date-widget-date-row">
          <div class="date-widget-date gregorian">
             {{ currentDate.toString().padStart(2, '0') }} / {{ (now.getMonth() + 1).toString().padStart(2, '0') }} / {{ now.getFullYear() }} 
          </div>
          <div class="date-widget-date hijri" :class="dateWidgetHijriClass">
            <!-- <div class="hijri-label">Hijri</div> -->
            {{ today.hijri.day }}  {{ today.hijri.month }} {{ today.hijri.year }}
          </div>
        </div>
        <!-- Only this part slides: Salah city info -->
        <div class="salah-flicking-container">
          <Flicking :options="{ renderOnlyVisible: true, align: 'center', panelsPerView: 1, circular: true }" :plugins="pluginsSalah" class="salah-flicking-inner">
            <div class="salah-city-slide" v-for="city in salahCityData" :key="city.name">
              <div class="city-name">{{ $t('city_' + city.name.toLowerCase()) }}</div>
              <div v-if="city.loading" class="salah-spinner">
                <span class="spinner-border spinner-border-sm"></span> {{ $t('loading') }}
              </div>
              <div v-else>
                <div class="salah-pill" :class="salahTextClass">
                  <span class="salah-pill-name">{{ $t('salah_' + getNextSalah(city.timings).name.toLowerCase()) }}:</span>
                  <span class="salah-pill-time">{{ format12hr(getNextSalah(city.timings).time) }}</span>
                </div>
              </div>
            </div>
          </Flicking>
        </div>
      </div>
    </div>
    <div class="section pb-2" v-if="data.important_links.length">
      <div class="transactions">
        <a v-for="important_links in data.important_links" v-bind:key="important_links"
          :href="important_links.link + (important_links.link_text == 'unit_id' ? this.currentUser.unit_id : '')"
          class="item">
          <div class="detail">
            <img :src="important_links.image" alt="img" class="image-block imaged w48">
            <div>
              <strong class="mal-text">{{ important_links.title }}</strong>
              <p class="mal-text">{{ important_links.desc }}</p>
            </div>
          </div>
          <div class="right">
            <div class="price text-primary"><ion-icon name="chevron-forward-outline"></ion-icon></div>
          </div>
        </a>
      </div>
    </div>

    <div class="section pb-2" v-if="reg_model_forms.length && !loading">
      <div class="section-heading">
        <h2 class="title">{{ $t('registration_links') }}</h2>
        <!-- <a href="javascript:void(0)" class="link">View All</a> -->
      </div>
      <div class="wrapper">
        <Flicking
          :options="{ renderOnlyVisible: true, align: 'prev', panelsPerView: data.reg_links_per_page ? data.reg_links_per_page : 2, circular: true }">
          <div class="bill-box" v-for="reg_model_form in reg_model_forms" v-bind:key="reg_model_form">
            <div class="img-wrapper" v-bind:class="reg_model_form.button_icon_color"
              v-if="!reg_model_form.button_image">
              <ion-icon :name="reg_model_form.button_icon"></ion-icon>
            </div>
            <div class="img-wrapper" v-if="reg_model_form.button_image">
              <img :src="reg_model_form.button_image" alt="img" class="image-block imaged w48">
            </div>
            <div class="price" v-bind:class="reg_model_form.form_heading_color" v-html="reg_model_form.form_heading">
            </div>
            <p v-bind:class="reg_model_form.title_color">{{ reg_model_form.title }}</p>
            <a href="javascript:void(0)" v-if="reg_model_form.form_button_status" @click="openFormModel(reg_model_form)"
              class="btn btn-block btn-sm" v-bind:class="reg_model_form.button_color">{{ reg_model_form.button_text
              }}</a>
          </div>
        </Flicking>
      </div>
    </div>
    <div class="section pt-0" v-if="data.news.length && !loading">
      <div class="section-heading">
        <h2 class="title">{{ $t('latest_news') }}</h2>
        <!-- <a href="javascript:void(0)" class="link">View All</a> -->
      </div>
      <div class="wrapper">
        <Flicking :options="{ renderOnlyVisible: true, align: 'prev', panelsPerView: 1, circular: true }"
          :plugins="pluginsNews">
          <div class="blog-card full-width" v-for="news in data.news" v-bind:key="news">
            <img :src="news.image" alt="image" class="imaged w-100 h-150">
            <div class="text">
              <router-link :to="'news/' + news.slug">
                <h5 class="title mal-text">{{ truncateText(news.title, 60) }}</h5>
                <a href="javascript:void(0)" class="link">{{ $t('read_more') }}</a>
              </router-link>
            </div>
          </div>
        </Flicking>
      </div>
    </div>
    <div class="section pt-2" v-if="data.apps.length && !loading">
      <div class="section-heading">
        <h2 class="title">{{ $t('apps_links') }}</h2>
        <!-- <a href="javascript:void(0)" class="link">View All</a> -->
      </div>
      <div class="wrapper">
        <Flicking :options="{ renderOnlyVisible: true, align: 'prev', panelsPerView: 2, circular: true }"
          :plugins="pluginsApps">
          <div class="bill-box" v-for="app in data.apps" v-bind:key="app">
            <div class="img-wrapper">
              <img :src="app.image" alt="img" class="image-block imaged w48">
            </div>
            <div class="price">{{ app.title }}</div>
            <p>{{ app.desc }}</p>
            <a :href="app.link" target="_blank" class="btn btn-primary btn-block btn-sm">{{ app.btn_text }}</a>
          </div>
        </Flicking>
      </div>
    </div>
    <div class="section mt-2 mb-1" v-if="data.social_links.length && !loading">
      <div class="card">
        <div class="card-body">
          <div class="p-1">
            <div class="text-center">
              <h2 class="text-primary">{{ $t('social_profiles') }}</h2>
              <a v-for="social in data.social_links" v-bind:key="social" :href="social.link" target="_blank"
                class="btn btn-icon me-05" v-bind:class="'btn-' + social.name">
                <ion-icon :name="'logo-' + social.name"></ion-icon>
              </a>

              <a href="https://www.youtube.com/@WisdomGlobalTV" target="_blank" class="btn btn-youtube btn-icon me-05">
                <ion-icon name="logo-youtube"></ion-icon>
              </a>

              <!-- <a href="#" class="btn btn-twitter btn-icon me-05" >
                <ion-icon name="logo-twitter"></ion-icon>
              </a>

              <a href="#" class="btn btn-linkedin btn-icon me-05">
                <ion-icon name="logo-linkedin"></ion-icon>
              </a>

              <a href="#" class="btn btn-whatsapp btn-icon me-05">
                <ion-icon name="logo-whatsapp"></ion-icon>
              </a>

              <a href="#" class="btn btn-instagram btn-icon me-05">
                <ion-icon name="logo-instagram"></ion-icon>
              </a>

              <a href="#" class="btn btn-twitch btn-icon me-05">
                <ion-icon name="logo-twitch"></ion-icon>
              </a> -->

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <transition name="home-notification-fade">
    <div
      v-if="showNotificationModal && latestNotification"
      class="home-notification-backdrop"
      @click.self="closeNotificationModal(true)"
    >
      <div class="home-notification-modal">
        <button
          type="button"
          class="home-notification-close"
          @click.stop="closeNotificationModal(true)"
          aria-label="Close notification"
        >
          <ion-icon name="close-outline"></ion-icon>
        </button>

        <div class="home-notification-header">
          <div class="home-notification-icon-wrapper">
            <ion-icon
              name="notifications-outline"
              class="home-notification-main-icon"
            ></ion-icon>
          </div>
          <div class="home-notification-title-wrap">
            <h5 class="home-notification-title">
              {{ latestNotification.data.title }}
            </h5>
          </div>
        </div>

        <div class="home-notification-body">
          <p class="home-notification-text">
            {{ latestNotification.data.description }}
          </p>
        </div>

        <div class="home-notification-footer">
          <button
            v-if="latestNotification.data.link"
            type="button"
            class="home-notification-link-button"
            @click="handleNotificationLinkClick"
          >
            {{ latestNotification.data.link_text || $t('click_here') || 'Click here' }}
          </button>
          <button
            v-else
            type="button"
            class="home-notification-link-button"
            @click="viewAllNotifications"
          >
            {{ $t('view_notifications') }}
          </button>
        </div>
      </div>
    </div>
  </transition>
  <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
  <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
    ref="dialog_model"></dialog-model>
</template>
<script>
import UserService from "../services/user.service";
import AuthService from "../services/auth.service";
import {
  fetchHomeContents,
  buildHomeBootstrapFromResponse,
} from "../services/home.service";
import 'vue3-carousel/dist/carousel.css';
// import { Carousel, Slide, Pagination } from 'vue3-carousel';
// import LiteYouTubeEmbed from 'vue-lite-youtube-embed'
import $ from 'jquery';
import 'vue-lite-youtube-embed/dist/style.css'

import AlertModel from "./layouts/AlertModel.vue";
import DialogModel from "./layouts/DialogModel.vue";
import * as yup from "yup";
import { AutoPlay } from "@egjs/flicking-plugins";
import Flicking from "@egjs/vue3-flicking";

export default {
  data() {
    const schema = yup.object().shape({
      name: yup.string().required('ഫിൽ ചെയ്യുക!'),
      age: yup.string().required('ഫിൽ ചെയ്യുക!'),
      gender: yup.string().required('സെലക്റ്റ് ചെയ്യുക!'),
    });
    const pluginsBanner = [new AutoPlay({ duration: 2000, direction: "NEXT", stopOnHover: false })];
    const pluginsApps = [new AutoPlay({ duration: 2000, direction: "NEXT", stopOnHover: false })];
    const pluginsNews = [new AutoPlay({ duration: 2000, direction: "NEXT", stopOnHover: false })];
    const pluginsSalah = [new AutoPlay({ duration: 2500, direction: "NEXT", stopOnHover: false })];
    return {
      pluginsBanner,
      pluginsApps,
      pluginsNews,
      pluginsSalah,
      sub_level_list_name: '',
      user_level: '',
      sub_levels: [],
      unit: [],
      user: [],
      schema,
      banners: [],
      country_code_list: [],
      code: '91',
      total_unit: 0.00,
      total_scheduled: 0.00,
      permissions: [],
      reg_model_forms: [],
      form_permissions: [],
      reg_model_title: '',
      reg_model_heading: '',
      reg_model_extra_fields: [],
      reg_model_button_text: '',
      reg_model_button_status: true,
      members: [],
      series: [0, 0],
      chartOptions: {
        chart: {
          width: '100%',
          type: 'pie',
        },
        colors: ['#64b167', '#db7491'],
        labels: ['Total Units', 'Total Unit Scheduled'],
        responsive: [{
          breakpoint: 300,
          options: {
            chart: {
              width: '100%'
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
      form_name: '',
      members_selected: [],
      new_reg: false,
      alert_type: '',
      alert_message: '',
      dialog_message: '',
      dialog_action: '',
      dialog_action_params: [],
      data: {
        news: [],
        apps: [],
        social_links: [],
        important_links: []
      },
      today: {
        gregorian: { date: "", day: "", month: "" },
        hijri: { date: "", day: "", month: "" },
      },
      timer: null,
      authCheckTimer: null,
      now: new Date(),
      salahTimes: {
        Fajr: '--:--',
        Dhuhr: '--:--',
        Asr: '--:--',
        Maghrib: '--:--',
        Isha: '--:--'
      },
      selectedCity: 'Thiruvananthapuram',
      cityOptions: [
        { name: 'Thiruvananthapuram', url: 'https://api.aladhan.com/v1/timings?latitude=8.5241&longitude=76.9366&method=1' },
        { name: 'Kochi', url: 'https://api.aladhan.com/v1/timings?latitude=9.9312&longitude=76.2673&method=1' },
        { name: 'Kozhikode', url: 'https://api.aladhan.com/v1/timings?latitude=11.258753&longitude=75.780411&method=1' },
        { name: 'Kasargod', url: 'https://api.aladhan.com/v1/timings?latitude=12.4984&longitude=74.9896&method=1' }
      ],
      loadingSalah: false,
      salahCityData: [
        { name: 'Thiruvananthapuram', url: 'https://api.aladhan.com/v1/timings?latitude=8.5241&longitude=76.9366&method=1', timings: {}, loading: true },
        { name: 'Kochi', url: 'https://api.aladhan.com/v1/timings?latitude=9.9312&longitude=76.2673&method=1', timings: {}, loading: true },
        { name: 'Kozhikode', url: 'https://api.aladhan.com/v1/timings?latitude=11.258753&longitude=75.780411&method=1', timings: {}, loading: true },
        { name: 'Kasargod', url: 'https://api.aladhan.com/v1/timings?latitude=12.4984&longitude=74.9896&method=1', timings: {}, loading: true }
      ],
      latestNotification: null,
      showNotificationModal: false,
      notificationExpiryTimer: null,
      notificationExpiryCheckInterval: null,
    };
  },
  components: {
    // Carousel,
    // Slide,
    // Pagination,
    // LiteYouTubeEmbed,
    AlertModel,
    DialogModel,
    Flicking
  },
  mounted() {
    localStorage.activeMenu = 'Home';
    this.checkAuthenticationAndProceed();
    
    // Timer for updating time
    this.timer = setInterval(() => {
      this.now = new Date();
    }, 1000);
    
    // Periodic authentication check (every 30 seconds)
    this.authCheckTimer = setInterval(() => {
      this.periodicAuthCheck();
    }, 30000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
    if (this.authCheckTimer) {
      clearInterval(this.authCheckTimer);
    }
    if (this.notificationExpiryTimer) {
      clearTimeout(this.notificationExpiryTimer);
      this.notificationExpiryTimer = null;
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    totalItem() {
      let members_sum = 0;
      let members_filled_sum = 0;

      let units_sum = 0;
      let units_scheduled_sum = 0;
      let units_election_sum = 0;

      this.sub_levels.forEach(element => {
        units_sum += element.units_count;
        units_scheduled_sum += element.elec_scheduled_units_count;
        units_election_sum += element.unit_election_completed_count;

        members_sum += element.members_count;
        members_filled_sum += element.members_count_filled;

      });
      let data = {
        members_sum: members_sum,
        members_filled_sum: members_filled_sum,
        units_sum: units_sum,
        units_scheduled_sum: units_scheduled_sum,
        units_election_sum: units_election_sum
      }
      return data;
    },
    currentTime() {
      // Format as HH:MM (12-hour) with leading zeros
      let hours = this.now.getHours();
      let minutes = this.now.getMinutes();
      let ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // 0 should be 12
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${ampm}`;
    },
    currentDay() {
      return this.now.toLocaleDateString('en-US', { weekday: 'long' });
    },
    currentMonth() {
      return this.now.toLocaleDateString('en-US', { month: 'long' });
    },
    currentDate() {
      return this.now.getDate();
    },
    currentSuffix() {
      // Add st, nd, rd, th
      const d = this.now.getDate();
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    },
    currentTimeOnly() {
      let hours = this.now.getHours();
      let minutes = this.now.getMinutes();
      hours = hours % 12;
      hours = hours ? hours : 12;
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    },
    currentAmPm() {
      return this.now.getHours() >= 12 ? 'PM' : 'AM';
    },
    dateWidgetIcon() {
      const hour = this.now.getHours();
      if (hour >= 5 && hour < 11) {
        return 'partly-sunny-outline'; // Morning: partly cloudy for light sky blue background
      } else if (hour >= 11 && hour < 16) {
        return 'cloudy-outline'; // Afternoon: cloudy for steel blue background
      } else if (hour >= 16 && hour < 19) {
        return 'cloudy-night-outline'; // Evening: cloudy night for slate gray background
      } else {
        return 'moon-outline'; // Night: moon for dark background
      }
    },
    dateWidgetBgClass() {
      const hour = this.now.getHours();
      if (hour >= 5 && hour < 11) {
        return 'date-widget-morning';
      } else if (hour >= 11 && hour < 16) {
        return 'date-widget-afternoon';
      } else if (hour >= 16 && hour < 19) {
        return 'date-widget-evening';
      } else {
        return 'date-widget-night';
      }
    },
    dateWidgetTextClass() {
      const hour = this.now.getHours();
      if (hour >= 5 && hour < 11) { // Morning: dark text for light sky blue background
        return 'date-widget-text-dark';
      } else if (hour >= 11 && hour < 16) { // Afternoon: dark text for steel blue background
        return 'date-widget-text-dark';
      } else {
        return 'date-widget-text-light'; // Evening & Night: light text for dark backgrounds
      }
    },
    dateWidgetIconClass() {
      const hour = this.now.getHours();
      if (hour >= 5 && hour < 11) { // Morning: dark icon for light sky blue background
        return 'date-widget-text-dark';
      } else if (hour >= 11 && hour < 16) { // Afternoon: dark icon for steel blue background
        return 'date-widget-text-dark';
      } else {
        return 'date-widget-text-light'; // Evening & Night: light icon for dark backgrounds
      }
    },
    dateWidgetHijriClass() {
      const hour = this.now.getHours();
      if (hour >= 11 && hour < 16) {
        return 'date-widget-hijri-dark'; // Afternoon: dark text for steel blue background
      } else if (hour >= 5 && hour < 11) {
        return 'date-widget-hijri-dark'; // Morning: dark text for light sky blue background
      } else {
        return 'date-widget-hijri-light'; // Evening & Night: light text for dark backgrounds
      }
    },
    nextSalah() {
      const now = this.now;
      const salahOrder = ['Fajr', 'Dhuhr', 'Asr', 'Maghrib', 'Isha'];
      for (let name of salahOrder) {
        const [h, m] = this.salahTimes[name].split(':');
        if (h === '--') continue;
        const salahDate = new Date(now);
        salahDate.setHours(Number(h), Number(m), 0, 0);
        if (now < salahDate) {
          return { name, time: this.salahTimes[name] };
        }
      }
      // If all have passed, next is Fajr tomorrow
      return { name: 'Fajr', time: this.salahTimes['Fajr'] };
    },
    formattedNextSalahTime() {
      // Format nextSalah.time as 12-hour with AM/PM
      const time = this.nextSalah.time;
      if (!time || time === '--:--') return '--:--';
      let [hour, minute] = time.split(':');
      hour = Number(hour);
      const ampm = hour >= 12 ? 'PM' : 'AM';
      hour = hour % 12;
      if (hour === 0) hour = 12;
      return `${hour.toString().padStart(2, '0')}:${minute} ${ampm}`;
    },
    currentCityTimings() {
      // Get timings for the currently centered city in the Flicking slider
      // For simplicity, use the first city or track the active index if you want
      return this.salahCityData[0]?.timings || {};
    },
    sunriseDate() {
      const timings = this.currentCityTimings;
      if (!timings || !timings.Sunrise) return null;
      const [h, m] = timings.Sunrise.split(':');
      const d = new Date(this.now);
      d.setHours(Number(h), Number(m), 0, 0);
      return d;
    },
    isAfterSunrise() {
      if (!this.sunriseDate) return false;
      return this.now >= this.sunriseDate;
    },
    dynamicBgClass() {
      // Use morning before sunrise, afternoon after
      if (!this.sunriseDate) return this.dateWidgetBgClass;
      if (this.now < this.sunriseDate) {
        return 'date-widget-morning';
      } else {
        // Use your existing logic for afternoon/evening/night if needed
        const hour = this.now.getHours();
        if (hour < 16) return 'date-widget-afternoon';
        if (hour < 19) return 'date-widget-evening';
        return 'date-widget-night';
      }
    },
    salahTextClass() {
      const hour = this.now.getHours();
      if (hour >= 5 && hour < 11) {
        return 'salah-text-dark'; // Morning: dark text for light sky blue background
      } else if (hour >= 11 && hour < 16) {
        return 'salah-text-dark'; // Afternoon: dark text for steel blue background
      } else if (hour >= 16 && hour < 19) {
        return 'salah-text-light'; // Evening: light text for slate gray background
      } else {
        return 'salah-text-light'; // Night: light text for dark background
      }
    },
  },
  methods: {
    checkAuthenticationAndProceed() {
      // Check if user is authenticated
      if (!this.currentUser) {
        this.handleLogout();
        return;
      }

      // Check if user has required authentication data
      if (!this.currentUser.id || !this.currentUser.accessToken) {
        this.handleLogout();
        return;
      }

      // User is authenticated, proceed with normal flow
      this.user_level = this.currentUser.user_level;
      this.loading = true;
      this.getHomeContents();
      this.fetchAllSalahTimes();
    },

    periodicAuthCheck() {
      // Silently check if user is still authenticated
      if (!this.currentUser || !this.currentUser.id || !this.currentUser.accessToken) {
        console.log('Periodic auth check failed - user no longer authenticated');
        this.handleLogout();
      }
    },

    handleLogout() {
      try {
        // Use the AuthService logout method to properly clear cookies and localStorage
        AuthService.logout();
        
        // Clear session storage as well
        sessionStorage.clear();
        
        // Dispatch store logout action
        if (this.$store && this.$store.dispatch) {
          this.$store.dispatch('auth/logout');
        }
        
        // Clear any remaining authentication-related items
        localStorage.removeItem('activeMenu');
        localStorage.removeItem('fcm');
        
        console.log('User logged out due to authentication failure on home page');
        
      } catch (error) {
        console.error('Error during logout:', error);
      } finally {
        // Always redirect to login page
        this.$router.replace('/login');
      }
    },
    getComboboxValues(code, id = null) {
      var data = {
        code: code,
        type_id: id
      }
      UserService.getCombobox(data).then(
        (response) => {
          switch (code) {
            case 'COUNTRY_CODE':
              this.country_code_list = response.data.data.list.options;
              this.country_code = '91';
              break;
            default:
              break;
          }

        },
        (error) => {
          this.loading = false;
          this.messafe = (error.response &&
            error.response.data &&
            error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },
    updateChart() {
      this.chartOptions = {
        chart: {
          type: 'pie'
        },
        colors: ['#64b167', '#db7491'],
        labels: ['Units Scheduled(' + this.totalItem.units_scheduled_sum + ')', 'Units Not Scheduled(' + (this.totalItem.units_sum - this.totalItem.units_scheduled_sum) + ')'],
        responsive: [{
          breakpoint: this.totalItem.units_sum,
          options: {
            chart: {
              width: '100%'
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      }
      // In the same way, update the series option
      this.series = [this.totalItem.units_scheduled_sum, (parseFloat(this.totalItem.units_sum) - parseFloat(this.totalItem.units_scheduled_sum))]
    },
    getHomeContents() {
      this.loading = true;
      fetchHomeContents().then(
        (response) => {
          if (response.data.status == 'success') {
            const payload = response.data.data;
            this.data = payload;
            this.user = payload.user;
            this.banners = payload.banners;
            this.permissions = payload.permissions;
            this.reg_model_forms = payload.forms;
            this.today = payload.calandar.today;
            this.members = payload.members;
            this.members.forEach(element => {
              if (element.qhls_reg == 1) {
                this.members_selected.push(element.id);
              }
            });

            const bootstrap = buildHomeBootstrapFromResponse(payload);
            // hasUpcomingMeetings is computed client-side (within one day) by the footer/meetings
            // indicator, so it is intentionally not overridden from the home bootstrap here.
            this.$store.commit('app/setHomeBootstrap', {
              unreadNotificationCount: bootstrap.unreadNotificationCount,
            });
            this.applyLatestNotificationModal(bootstrap.latestNotification);

            this.loading = false;
          } else {
            this.loading = true;
          }
        },
        (error) => {
          this.loading = false;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          
          if (this.message === 'Unauthenticated.' || 
              error.response?.status === 401 || 
              error.response?.status === 403) {
            console.log('Authentication error detected in getHomeContents:', this.message);
            this.handleLogout();
          }
        }
      );
    },
    applyLatestNotificationModal(candidate) {
      if (!candidate) {
        return;
      }
      this.latestNotification = candidate;
      this.showNotificationModal = true;
      this.scheduleNotificationAutoHide();
    },
    getSubLevels() {
      this.loading = true;
      if (this.user_level == 2) {
        this.currentUser.district_id;
      } else if (this.user_level == 3) {
        this.currentUser.zone_id;
      } else if (this.user_level == 4) {
        this.currentUser.unit_id;
      }
      let data = {
        sub_level_type: this.user_level + 1,
        id: this.user_level_id
      }
      UserService.getSubLevels('get-sub-levels', data).then(
        (response) => {
          if (response.data.status == 'success') {
            this.loading = false;
            this.sub_levels = response.data.data.list;
            this.unit = response.data.data.unit;
            this.$root.updateParent(response.data.data.page_title);
            this.updateChart();
          } else {
            this.loading = true;
          }
        },
        (error) => {
          this.loading = false;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          
          // Handle authentication errors
          if (this.message === 'Unauthenticated.' || 
              error.response?.status === 401 || 
              error.response?.status === 403) {
            console.log('Authentication error detected in getSubLevels:', this.message);
            this.handleLogout();
          }
        }
      );
    },
    openFormModel(form) {
      this.$router.push('events/' + form.event_type);
      // this.new_reg = false;
      // this.form_permissions = form.permissions;
      // this.new_reg_text = form.new_reg_text?form.new_reg_text:'പുതിയ ഒരാളെ രജിസ്റ്റർ ചെയ്യാൻ ഇവിടെ ക്ലിക്ക് ചെയ്യുക.';
      // this.reg_model_heading = form.form_heading;
      // this.reg_model_title = form.form_title;
      // this.reg_model_button_text = form.form_button_text;
      // this.form_name = form.form_name;
      // this.reg_model_button_status = form.form_button_status;
      // $('#regFormModel').modal('show');
    },
    closeModel() {
      $('#regFormModel').modal('hide');
    },
    modelAction(reg_data = null) {
      if (this.members_selected.length == 0 && !this.new_Reg) {
        this.alert_type = 'Warning';
        this.alert_message = 'പേര് ടിക്ക് ചെയ്തതിനു ശേഷം സേവ് ചെയ്യുക.';
        this.$refs.alert_model.openModel();
        this.loading = false;
      } else {
        var data = {
          new_reg: this.new_reg,
          user_type: this.user.user_type,
          form_name: this.form_name,
          members: this.members_selected,
          new: {
            name: reg_data.name,
            code: reg_data.code,
            mobile: reg_data.mobile,
            gender: reg_data.gender,
            age: reg_data.age,

          }
        };
        UserService.addAdmin('auto-form-submit', data).then(
          (response) => {
            if (response.data.status == 'success') {
              this.alert_type = 'Success';
              this.members = response.data.members;
              this.alert_message = response.data.message;
              this.$refs.alert_model.openModel();
              this.loading = false;
              this.message = '';
              $('#regFormModel').modal('hide');
            } else if (response.data.status == 'warning') {
              this.alert_type = 'Warning';
              this.alert_message = response.data.message;
              this.$refs.alert_model.openModel();
              this.loading = false;
            } else if (response.data.status == 'error') {
              this.alert_type = 'Error';
              this.alert_message = response.data.message;
              this.$refs.alert_model.openModel();
              this.loading = false;
            } else {
              this.loading = false;
            }
          },
          (error) => {
            this.alert_type = 'Error';
            this.alert_message = (error.response &&
              error.response.data &&
              error.response.data.message) ||
              error.message ||
              error.toString();
            this.$refs.alert_model.openModel();
            this.loading = false;
          }
        );
      }
    },
    truncateText(text, limit) {
      if (typeof text !== 'string') return '';
      if (text.length > limit) {
        return text.slice(0, limit) + (text.length > limit ? '...' : '');
      } else {
        return text;
      }
    },
    getSalahCacheKey(cityName) {
      const dateKey = new Date().toISOString().slice(0, 10);
      return `salah_timings_${dateKey}_${cityName}`;
    },
    loadSalahTimingsFromCache(city) {
      try {
        const cached = sessionStorage.getItem(this.getSalahCacheKey(city.name));
        if (!cached) return false;
        city.timings = JSON.parse(cached);
        city.loading = false;
        return true;
      } catch (e) {
        return false;
      }
    },
    saveSalahTimingsToCache(city, timings) {
      try {
        sessionStorage.setItem(this.getSalahCacheKey(city.name), JSON.stringify(timings));
      } catch (e) {
        // Ignore quota errors
      }
    },
    async fetchAllSalahTimes() {
      for (let city of this.salahCityData) {
        if (this.loadSalahTimingsFromCache(city)) {
          continue;
        }
        city.loading = true;
        try {
          const response = await fetch(city.url);
          const data = await response.json();
          if (data.code === 200) {
            city.timings = {
              Fajr: data.data.timings.Fajr,
              Dhuhr: data.data.timings.Dhuhr,
              Asr: data.data.timings.Asr,
              Maghrib: data.data.timings.Maghrib,
              Isha: data.data.timings.Isha
            };
            this.saveSalahTimingsToCache(city, city.timings);
          }
        } catch (e) {
          city.timings = {};
        } finally {
          city.loading = false;
        }
      }
      this.salahCityData = [...this.salahCityData];
    },
    getNextSalah(timings) {
      if (!timings || !timings.Fajr) return { name: '', time: '--:--' };
      const now = new Date();
      const salahOrder = ['Fajr', 'Dhuhr', 'Asr', 'Maghrib', 'Isha'];
      for (let name of salahOrder) {
        const [h, m] = timings[name].split(':');
        if (h === '--') continue;
        const salahDate = new Date(now);
        salahDate.setHours(Number(h), Number(m), 0, 0);
        if (now < salahDate) {
          return { name, time: timings[name] };
        }
      }
      return { name: 'Fajr', time: timings['Fajr'] };
    },
    format12hr(time) {
      if (!time || time === '--:--') return '--:--';
      let [hour, minute] = time.split(':');
      hour = Number(hour);
      const ampm = hour >= 12 ? 'PM' : 'AM';
      hour = hour % 12;
      if (hour === 0) hour = 12;
      return `${hour.toString().padStart(2, '0')}:${minute} ${ampm}`;
    },
    scheduleNotificationAutoHide() {
      if (this.notificationExpiryTimer) {
        clearTimeout(this.notificationExpiryTimer);
        this.notificationExpiryTimer = null;
      }
      if (this.notificationExpiryCheckInterval) {
        clearInterval(this.notificationExpiryCheckInterval);
        this.notificationExpiryCheckInterval = null;
      }

      if (!this.latestNotification || !this.latestNotification.expires_at) {
        return;
      }

      const checkExpired = () => {
        if (!this.latestNotification?.expires_at || !this.showNotificationModal) return;
        if (Date.now() >= new Date(this.latestNotification.expires_at).getTime()) {
          this.showNotificationModal = false;
          if (this.notificationExpiryTimer) {
            clearTimeout(this.notificationExpiryTimer);
            this.notificationExpiryTimer = null;
          }
          if (this.notificationExpiryCheckInterval) {
            clearInterval(this.notificationExpiryCheckInterval);
            this.notificationExpiryCheckInterval = null;
          }
        }
      };

      const now = Date.now();
      const expiresAtMs = new Date(this.latestNotification.expires_at).getTime();
      const remaining = expiresAtMs - now;

      if (remaining <= 0) {
        this.showNotificationModal = false;
        return;
      }

      this.notificationExpiryTimer = setTimeout(() => {
        this.showNotificationModal = false;
        this.notificationExpiryTimer = null;
        if (this.notificationExpiryCheckInterval) {
          clearInterval(this.notificationExpiryCheckInterval);
          this.notificationExpiryCheckInterval = null;
        }
      }, remaining);

      // Periodic check so popup closes even if client/server time or timer is off
      this.notificationExpiryCheckInterval = setInterval(checkExpired, 10000);
    },
    closeNotificationModal(markAsRead = false) {
      if (this.notificationExpiryTimer) {
        clearTimeout(this.notificationExpiryTimer);
        this.notificationExpiryTimer = null;
      }
      if (this.notificationExpiryCheckInterval) {
        clearInterval(this.notificationExpiryCheckInterval);
        this.notificationExpiryCheckInterval = null;
      }
      if (this.latestNotification) {
        if (markAsRead) {
          this.markHomeNotificationAsRead(this.latestNotification.id);
        }
      }
      this.showNotificationModal = false;
    },
    markHomeNotificationAsRead(id) {
      UserService.authPostRequest('notifications/mark-as-read', { id }).then(
        () => {},
        () => {}
      );
    },
    handleNotificationLinkClick() {
      if (!this.latestNotification || !this.latestNotification.data) {
        this.viewAllNotifications();
        return;
      }

      const link = this.latestNotification.data.link;
      if (!link) {
        this.viewAllNotifications();
        return;
      }

      // Mark as read and close the popup
      this.closeNotificationModal(true);

      // External vs internal links
      if (link.startsWith('http://') || link.startsWith('https://')) {
        window.open(link, '_blank');
      } else {
        this.$router.push(link);
      }
    },
    viewAllNotifications() {
      this.closeNotificationModal(true);
      this.$router.push('/notifications');
    }
  },

};
</script>
<style scoped>
.blue-head {
  color: blue;
}

.carousel__slide {
  width: 100% !important;
}



.card-title {
  font-weight: 600 !important;
}

th {
  padding: 5px !important;
  font-size: 12px;
}

td {
  padding: 5px !important;
}

.wallet-card .wallet-footer .item .icon-wrapper {
  width: 100%;
  height: 48px;
  display: inline-flex;
  align-items: left;
  justify-content: left;
  border-radius: 10px;
  color: #fff;
  /* font-size: 28px; */
  margin-bottom: 14px;
  padding-left: 10px;
}

.menu-icon {
  font-size: 32px !important;
}

.menu-title {
  color: #fff !important;
  font-size: 12px !important;
  padding-left: 5px !important;
  text-align: left !important;
}

.btn-cancel {
  left: 4% !important;
}

.forget {
  font-size: 12px !important;
  text-decoration: underline;
}

.error-feedback {
  color: red;
}

.form_result_list {
  margin-left: 0px !important;
  margin-right: 0px !important;
  overflow: hidden;
  border: 0;
  border-radius: 10px;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
  font-size: 12px !important;
}

.list-item-text {
  font-size: 14px !important;
  ;
}

.sl-no {
  font-weight: 600;
  font-size: 16px;
}

.card .card-img-top {
  border-radius: 10px 10px 10px 10px;
}

.blog-card,
.bill-box {
  width: 50%;
  margin-left: 20px;
}

.full-width {
  width: 100% !important;
}

.bill-box p {
  font-size: 12px;
  min-height: 40px;
}

.h-150 {
  height: 180px !important;
}

.bill-box .price {
  font-size: 20px;
  font-weight: 700;
  color: #27173E;
  letter-spacing: -0.02em;
  line-height: 1em;
  margin-bottom: 12px;
  min-height: 40px;
}

.blog-card .title {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5em;
  height: 50px;
  overflow: hidden;
}

.blog-card .text {
  padding: 5px 5px;
}

.stat-box {
  background: #ffffff;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
  border-radius: 10px;
  padding: 10px 20px;
}

.transactions .item {
  background: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.09);
  border-radius: 10px;
  padding: 5px 5px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.price {
  font-size: 50px;
}

.section-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 15px 25px;
  border-radius: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  margin: 10px 0;
}

.title {
  margin: 0;
  padding: 0;
  font-weight: 600;
  position: relative;
}

.title.text-danger {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5253 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 18px !important;
}

.title.text-primary {
  background: linear-gradient(135deg, #4834d4 0%, #686de0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 18px !important;
}

.section-heading:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.date-box {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 12px 20px;
  margin: 10px 0;
}

.date-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.date-value {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.3px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.date-value.text-danger {
  color: #dc3545 !important;
}

.date-value.text-primary {
  color: #0d6efd !important;
}

/* Remove unused styles */
.date-label, .separator, .date-row, .date-separator {
  display: none;
}

.date-widget-card {
  color: #fff;
  border-radius: 20px;
  padding: 23px 28px 6px 28px;
  margin: 10px auto;
  font-family: 'Segoe UI', 'Arial', sans-serif;
  position: relative;
  line-height: 15px;
  font-weight: 500;
}
.date-widget-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.date-widget-time-group {
  display: flex;
  align-items: baseline;
  gap: 6px;
}
.date-widget-time {
  font-size: 2rem;
  font-family: 'Roboto Mono', 'Consolas', monospace;
  font-weight: 700;
  letter-spacing: 0.05em;
}
.date-widget-ampm {
  font-size: 1rem;
  font-weight: 600;
  margin-left: 2px;
  opacity: 0.8;
  letter-spacing: 0.03em;
}
.date-widget-icon {
  font-size: 1.5rem;
  color: #fff;
  opacity: 0.8;
}
.date-widget-date-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 15px;
  gap: 10px;
}
.date-widget-date.year {
  text-align: left;
  flex: 1;
}
.date-widget-date.hijri {
  text-align: right;
  flex: 1;
}
.gregorian-label, .hijri-label {
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  opacity: 0.7;
  margin-bottom: 2px;
}
.gregorian-label {
  color: #fff;
}
.hijri-label {
  color: #4ea8ff;
}
.date-widget-morning {
  background: linear-gradient(135deg, #87CEEB 0%, #B0E0E6 100%);
}
.date-widget-afternoon {
  background: linear-gradient(135deg, #4682B4 0%, #87CEEB 100%);
}
.date-widget-evening {
  background: linear-gradient(135deg, #708090 0%, #2F4F4F 100%);
}
.date-widget-night {
  background: linear-gradient(135deg, #232946 0%, #1a1a2e 100%);
}
.date-widget-text-dark {
  color: #1a1a1a !important;
}
.date-widget-text-light {
  color: #fff !important;
}
.date-widget-hijri-yellow {
  color: #1a1a1a !important;
}
.date-widget-hijri-dark {
  color: #1a1a1a !important;
}
.date-widget-hijri-light {
  color: #fff !important;
}
.salah-city-select {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  gap: 8px;
}
.salah-city-select select {
  border-radius: 6px;
  padding: 2px 8px;
  font-size: 1rem;
}
.salah-time-row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 18px;
  gap: 10px;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 8px;
  background: rgba(255,255,255,0.07);
  padding: 8px 0 4px 0;
  min-height: 36px;
}
.salah-spinner {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #000000;
  font-size: 1rem;
}
.salah-name {
  font-weight: bold;
  margin-left: 8px;
}
.salah-time {
  font-family: 'Roboto Mono', monospace;
  margin-left: 8px;
  font-size: 1.1rem;
}
.salah-flicking {
  margin-top: 18px;
  margin-bottom: 0;
}
.salah-city-slide {
  width: 100%;
  margin: 0 auto;
  padding: 10px 18px;
  border-radius: 16px;
  font-size: 1rem;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
}

.city-name {
  font-weight: bold;
  font-size: 1.1rem;
  margin-bottom: 6px;
  letter-spacing: 0.5px;
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
}

.salah-label {
  font-size: 0.95rem;
  color: #b0b0b0;
  margin-bottom: 4px;
  letter-spacing: 0.5px;
}

.salah-pill {
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  padding: 6px 18px;
  font-weight: bold;
  font-size: 1rem;
  box-shadow: none;
  margin-top: 2px;
  gap: 10px;
}

.salah-pill-name {
  font-size: 1em;
  font-weight: bold;
  letter-spacing: 0.5px;
}

.salah-pill-time {
  font-family: 'Roboto Mono', monospace;
  font-size: 1em;
  font-weight: bold;
  letter-spacing: 1px;
}

/* Keep these for dynamic color */
.salah-text-dark {
  color: #232946 !important;
}
.salah-text-light {
  color: #fff !important;
}
.salah-flicking-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 0;
}
.salah-flicking-inner {
  width: 100%;
  max-width: 320px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.date-widget-night .hijri-label {
  color: #fff !important;
}
.salah-text-dark {
  color: #232946 !important; /* dark blue for morning */
}
.salah-text-light {
  color: #fff !important; /* white for afternoon, evening, night */
}

.home-notification-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.home-notification-modal {
  position: relative;
  background: #ffffff;
  border-radius: 18px;
  padding: 16px 18px 16px 18px;
  max-width: 360px;
  width: calc(100% - 40px);
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.25);
}

.home-notification-icon-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1b75d0, #4da3ff);
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);
  margin-right: 10px;
}

.home-notification-main-icon {
  font-size: 20px;
  color: #ffffff;
}

.home-notification-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.04);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.home-notification-close ion-icon {
  font-size: 16px;
  color: #555;
}

.home-notification-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 8px;
}

.home-notification-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  text-align: left;
}

.home-notification-title-wrap {
  flex: 1;
  min-width: 0;
}

.home-notification-body {
  font-size: 14px;
  color: #555;
  margin-bottom: 14px;
  max-height: 160px;
  overflow-y: auto;
  text-align: left;
}

.home-notification-text {
  margin: 0;
  white-space: pre-line;
}

.home-notification-footer {
  display: flex;
  justify-content: flex-end;
}

.home-notification-link-button {
  border-radius: 999px;
  border: none;
  padding: 8px 18px;
  background: #1b75d0;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 6px 16px rgba(27, 117, 208, 0.45);
}

.home-notification-fade-enter-active,
.home-notification-fade-leave-active {
  transition: opacity 0.22s ease;
}

.home-notification-fade-enter-from,
.home-notification-fade-leave-to {
  opacity: 0;
}

.home-notification-fade-enter-active .home-notification-modal,
.home-notification-fade-leave-active .home-notification-modal {
  transition: transform 0.22s ease;
}

.home-notification-fade-enter-from .home-notification-modal,
.home-notification-fade-leave-to .home-notification-modal {
  transform: translateY(12px) scale(0.96);
}

</style>